import { Icon, IconNewTab } from '@flixbus/honeycomb-icons-react';
import { Divider, FooterNav, NavItem, PageContainer, Switch, Text } from '@flixbus/honeycomb-react';
import { Link as RouterLink } from 'react-router-dom';

import useGlobalHelpLink from '../../hooks/useGlobalHelpLink';
import './Footer.css';

function Footer(props) {
  const globalHelpLink = useGlobalHelpLink();
  return (
    <div className="footer">
      <footer>
        <Divider />
        <PageContainer extraClasses="footer__container">
          <FooterNav extraClasses="footer__nav" horizontal>
            <NavItem to="/imprint" RouterLink={RouterLink}>
              Imprint
            </NavItem>
            <NavItem to="/contact" RouterLink={RouterLink}>
              Contact
            </NavItem>
            <NavItem to="/design" RouterLink={RouterLink}>
              Design
            </NavItem>
            <NavItem href={globalHelpLink}>
              Help <Icon style={{ fill: 'currentColor' }} InlineIcon={IconNewTab} aria-label="Opens in a New Tab" />
            </NavItem>
            <NavItem to="/faq" RouterLink={RouterLink}>
              FAQ
            </NavItem>
            <NavItem extraClasses="footer__copyright">
              <Text extraClasses="footer__copyright" Elem="small">
                © 2022 Flix SE
              </Text>
            </NavItem>
            <NavItem>
              <Switch
                extraClasses="footer__switchers"
                small
                label="Dark mode"
                id="theme-wrapper-theme-switch"
                value=""
                onChange={props.themeToggleHandler}
                defaultChecked={props.theme !== 'flix'}
              />
            </NavItem>
          </FooterNav>
        </PageContainer>
      </footer>
    </div>
  );
}

export default Footer;
